import * as yup from "yup";

import { CommonErrors } from "application/constants/validations";

export const questionSchema = yup.object({
  question: yup.string().required(CommonErrors.requiredField),
  replyLanguage: yup.string().required(CommonErrors.requiredField),
});
